<script setup lang="ts">
defineProps<{ withSearchBar?: boolean }>()
</script>

<template>
  <div
    :class="withSearchBar && 'lg:pt-3'"
    class="
      w-full h-[58px] px-3 lg:h-[84px] lg:px-6
      flex items-center transition transition-all duration-200
      ease-in-out
    "
  >
    <div class="w-full flex items-center justify-between h-15">
      <slot/>

    </div>
  </div>
</template>
